import { init, logToDataDog } from '../ddTooling';
import { ApolloClient, from, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { RestLink } from 'apollo-link-rest';
import typePatcher from './rest-link/typePatcher';
import { LocalForageWrapper, persistCache } from 'apollo3-cache-persist';
import localforage from 'localforage';
import photos from './type-policies/search-fragment/photos';

init();

const { protocol, host } = window.location;

const uri = `${protocol}//${host}`;

export const cache = new InMemoryCache({
  typePolicies: {
    SearchFragment: {
      merge: (existing = {}, incoming = {}, { mergeObjects, isReference, toReference }) =>
        mergeObjects(existing, isReference(incoming) ? incoming : toReference(incoming, true)),
      fields: {
        photos,
      },
    },
  },
});

// await before instantiating ApolloClient, else queries might run before the cache is persisted
await persistCache({
  cache,
  storage: new LocalForageWrapper(localforage),
});
export const buildGQLClient = (): ApolloClient<Record<string, unknown>> => {
  const httpLink = new HttpLink({ uri });

  const restLink = new RestLink({
    endpoints: { bff: uri },
    typePatcher,
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) =>
        logToDataDog(`[GraphQL error]: Message: ${message}`, { locations, path })
      );
    }

    if (networkError) {
      logToDataDog(`[Network error]: ${networkError}`);
    }
  });

  return new ApolloClient({
    link: from([errorLink, restLink, httpLink]),
    cache,
  });
};
